'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _theme = require('../../theme');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// SlideTheme provides computed theme defaults
// to child components on a slide.
var themeTransformer = function themeTransformer(theme) {
  var slideTheme = {};
  var inheritedKeys = ['baseFont', 'monoFont', 'textColor'];

  inheritedKeys.forEach(function (key) {
    return slideTheme[key] = theme[key];
  });
  Object.assign(slideTheme, _theme.defaultSlideTheme, theme.slide);

  return _extends({}, theme, {
    slide: slideTheme
  });
};

var SlideTheme = function SlideTheme(props) {
  return _react2.default.createElement(_styledComponents.ThemeProvider, _extends({ theme: themeTransformer }, props));
};

exports.default = SlideTheme;